/**
 * عرض المحتوى قرارٌ دلاليّ بحسب نوع الشاشة، لا سقفٌ واحد على التطبيق كله.
 * كان `max-w-content` يحبس لوحات «اليوم» والمشاريع والأشخاص داخل 860px،
 * فينهار تركيب العمودين قبل أن تبلغ الشاشة نقطة كسره. BestVersion يختار
 * العرض بحسب المهمة؛ وهذه الخريطة تجعل القرار صريحًا ومختبرًا في مكان واحد.
 */
export type ContentWidth = 'compact' | 'standard' | 'wide' | 'dashboard' | 'full';

export const CONTENT_WIDTH_CLASS: Readonly<Record<ContentWidth, string>> = {
  compact: 'max-w-3xl',
  standard: 'max-w-5xl',
  wide: 'max-w-6xl',
  dashboard: 'max-w-[1280px]',
  full: 'max-w-none',
};

export function contentWidthForPath(pathname: string): ContentWidth {
  if (pathname === '/personal/pmp') return 'full';

  if (
    pathname === '/' ||
    pathname === '/projects' ||
    pathname.startsWith('/projects/') ||
    pathname.startsWith('/ventures/')
  ) {
    return 'dashboard';
  }

  if (
    pathname === '/personal' ||
    (pathname.startsWith('/personal/') && pathname !== '/personal/notebook')
  ) {
    return 'wide';
  }

  if (pathname === '/settings') return 'standard';
  if (pathname === '/oauth/consent') return 'compact';

  return 'standard';
}
